import { useQuery } from "@tanstack/react-query";
import klydoApiClient from "../../../api/klydo";
import { Label } from "../../../api/label";

const useAllKlydoLabels = () => {
  return useQuery<Label[]>({
    queryKey: ["klydo-labels-all"],
    queryFn: () => klydoApiClient.getAllKlydoLabels(),
  });
};

export default useAllKlydoLabels;
